import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";

import { TextButton } from "@/components/ui/buttons/TextButton/TextButton";

import type { DropdownProps, MultiDropdownProps } from "./Dropdown";

type DropdownListBoxSelectionBarProps<TKey extends Key = Key> = Pick<MultiDropdownProps<TKey>, "onChange"> &
  Pick<DropdownProps<TKey>, "items"> & {
    className?: string;
  };

export const DropdownListBoxSelectionBar = <TKey extends Key = Key>({
  className,
  onChange,
  items,
}: DropdownListBoxSelectionBarProps<TKey>) => {
  const { t } = useTranslation();

  return (
    <div className={`${className} flex items-center justify-between border-secondary-75 border-b px-4 py-1-5`}>
      <TextButton
        type="button"
        color="primary"
        onPress={() => {
          onChange(items.map((item) => item.id));
        }}
      >
        {t("ui.dropdown.selectAll")}
      </TextButton>
      <TextButton
        type="button"
        color="secondary"
        onPress={() => {
          onChange([]);
        }}
      >
        {t("ui.dropdown.clearSelection")}
      </TextButton>
    </div>
  );
};
